import { CIcon } from '~/icons/types'

export const ciUndo: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M21.52 9.147a10.046 10.046 0 0 0-3.841-5.293 10.056 10.056 0 0 0-6.29-1.788 10.058 10.058 0 0 0-6.058 2.489L4 5.753V2a1 1 0 0 0-2 0v6c0 .052.022.097.03.147.011.07.016.139.042.206.028.076.075.139.121.205.024.035.035.076.064.109.005.006.013.008.018.013.061.065.136.11.212.157.035.022.065.053.102.07.065.029.137.037.208.052.057.012.112.033.17.034.012.001.022.007.033.007h6a1 1 0 0 0 0-2H5.604l1.057-.951a8.04 8.04 0 0 1 4.84-1.986 8.007 8.007 0 0 1 5.031 1.43 8.034 8.034 0 0 1 3.073 4.234 8.044 8.044 0 0 1-.201 5.228 8.038 8.038 0 0 1-3.388 3.985 8.03 8.03 0 0 1-5.127 1.04 8.023 8.023 0 0 1-4.673-2.352 8.028 8.028 0 0 1-2.221-4.736 1 1 0 1 0-1.989.211 10.035 10.035 0 0 0 2.777 5.92 10.031 10.031 0 0 0 5.841 2.939 10.052 10.052 0 0 0 6.409-1.3 10.047 10.047 0 0 0 4.235-4.981c.809-2.077.899-4.398.252-6.534Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'undo',
  type: 'regular'
}
